import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

export const SITE_URL = 'https://www.matrixprint.si';
const DEFAULT_IMAGE = `${SITE_URL}/assets/hero-merch.jpg`;
const LOCALES = { sl: 'sl_SI', en: 'en_GB', it: 'it_IT' };
const GSC = process.env.REACT_APP_GSC_VERIFICATION;

export const Seo = ({ title, description, image = DEFAULT_IMAGE, type = 'website', jsonLd }) => {
  const { pathname } = useLocation();
  const { language, t } = useLanguage();
  const path = pathname === '/' ? '/' : pathname.replace(/\/$/, '');
  const urlFor = (lang) => `${SITE_URL}${path}${lang === 'sl' ? '' : `?lang=${lang}`}`;
  const canonical = urlFor(language);
  const pageTitle = t(title);
  const pageDescription = t(description);

  return (
    <Helmet prioritizeSeoTags>
      <html lang={language} />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      {GSC && <meta name="google-site-verification" content={GSC} />}
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="sl" href={urlFor('sl')} />
      <link rel="alternate" hrefLang="en" href={urlFor('en')} />
      <link rel="alternate" hrefLang="it" href={urlFor('it')} />
      <link rel="alternate" hrefLang="x-default" href={urlFor('sl')} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Matrix Print" />
      <meta property="og:locale" content={LOCALES[language]} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={image} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
